import type {
  SearchConfigFilter,
  SearchConfigFilterOption,
  SearchConfigFilterOptionWithChildren,
} from "@/modules/user/api/types"

const isSearchConfigFilterOptionWithChildren = (
  searchConfigFilterOption: SearchConfigFilterOption | SearchConfigFilterOptionWithChildren
): searchConfigFilterOption is SearchConfigFilterOptionWithChildren => {
  return searchConfigFilterOption.hasOwnProperty("children")
}

export const computeAvailableSearchConfigOptions = (searchConfigFilter: SearchConfigFilter): string[] => {
  const options = searchConfigFilter.options as (SearchConfigFilterOption | SearchConfigFilterOptionWithChildren)[]

  return options.reduce(
    (availableTypes: string[], option: SearchConfigFilterOption | SearchConfigFilterOptionWithChildren) =>
      availableTypes.concat(
        isSearchConfigFilterOptionWithChildren(option)
          ? (option.children as SearchConfigFilterOption[]).map(child => child.name)
          : [option.name]
      ),
    []
  )
}
